import LinkFromNext from 'next/link'
// import { useRouter } from 'next/router'
import type { ReactNode, AnchorHTMLAttributes } from 'react'
import { DOMAIN } from '@/root/constants'

export type LinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'className'
> & {
  openInNewTab?: boolean
  children: ReactNode
  href: string
  title?: string
  /** @deprecated */
  aTagClassNames?: string
  // duplicate prop so that
  // 1. we keep supporting aTagClassNames usage, eventually can be refactored to remove aTagClassNames
  // 2. add className prop so that we get tailwindcss suggestions, can be the only prop once (1.) refactor is done.
  className?: string
  /** this prop is useful for incremental porting of pages
   * from other apps ( web-ssr, glitter ) to stencil
   */
  nativeAnchor?: boolean
  absoluteUrlScheme?: boolean
}

export default function Link({
  openInNewTab,
  children,
  href,
  title,
  aTagClassNames = '',
  className = '',
  nativeAnchor = false,
  absoluteUrlScheme = false,
  ...rest
}: LinkProps) {
  // const router = useRouter()

  const conditionalProps: { rel?: string; target?: '_blank' } = {}

  // if (!openInNewTab && router.pathname.includes('iframe')) {
  //   href = `${href}/iframe`
  // }
  if (openInNewTab) {
    conditionalProps.rel = 'noreferrer noopener nofollow'
    conditionalProps.target = '_blank'
  }

  const finalClassName = aTagClassNames || className

  if (nativeAnchor) {
    const link =
      process.env.NODE_ENV === 'development' || absoluteUrlScheme
        ? `${DOMAIN}${href}`
        : href

    return (
      <a
        {...conditionalProps}
        className={finalClassName}
        href={link}
        {...rest}
        title={title}
      >
        {children}
      </a>
    )
  }

  return (
    <LinkFromNext href={href} passHref prefetch={false} legacyBehavior>
      <a
        {...conditionalProps}
        className={finalClassName}
        {...rest}
        title={title}
      >
        {children}
      </a>
    </LinkFromNext>
  )
}
